import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TextArea, Popup, Select } from '_atoms';
import { STATUSES } from 'constants/user';
import { getCandidateInfo, getJobs, setCandidateMarkAsFired } from 'actions';
import { getCandidateJobs } from 'store/selectors/candidateSelectors';
import { useAppDispatch } from 'store';
import './style.scss';

interface JobOption {
  value: string;
  label: string;
}

interface PopupFireProps {
  open: boolean;
  onClose: () => void;
}

export const PopupFire: React.FC<PopupFireProps> = ({ open, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const [firing_comment, setComment] = useState('');
  const [job, setJob] = useState<JobOption | undefined>(undefined);
  const onChangeComment = (e: React.ChangeEvent<HTMLTextAreaElement>) => setComment(e.target.value);

  const candidateJobs = useSelector(getCandidateJobs);
  const jobOptions = useMemo(
    () =>
      candidateJobs.filter(j => j.candidate_status === STATUSES.HIRED).map(j => ({ value: j.job_uuid, label: j.job })),
    [candidateJobs]
  );

  const onClosePopup = () => {
    setComment('');
    setJob(undefined);
    onClose();
  };

  const onBlackList = () => {
    setCandidateMarkAsFired(id, job.value, { firing_comment }).then(() => {
      dispatch(getCandidateInfo(id));
      dispatch(getJobs(id));
      onClosePopup();
    });
  };

  useEffect(() => {
    if (jobOptions.length === 1) setJob(jobOptions[0]);
  }, [jobOptions]);

  return (
    <Popup
      open={open}
      title={t('translation:popup_fire.title')}
      className="fire-candidate-popup"
      cancelButtonProps={{
        children: t('translation:popup_fire.button_cancel'),
        onClick: onClosePopup,
      }}
      okButtonProps={{
        children: t('translation:popup_fire.button_fire'),
        disabled: !firing_comment || !job,
        onClick: onBlackList,
      }}
    >
      <Select
        label={t('translation:popup_fire.label_job')}
        value={job}
        onChange={setJob}
        options={jobOptions}
        disabled={jobOptions.length < 2}
      />
      <TextArea
        label={t('translation:popup_fire.label_comment')}
        value={firing_comment}
        placeholder={t('translation:popup_fire.placeholder_comment')}
        onChange={onChangeComment}
      />
    </Popup>
  );
};
